import { Observable } from 'rxjs';
import { UseCase } from '../../../base/use-case';
import { ConfigurationRepository } from '../../../repositories/configuration.repository';
import { ConvenioModel } from '../../../models/configuration/convenio.model';

export class GetConveniosByEmpresaUseCase implements UseCase<void, ConvenioModel>{
	constructor(private configRepository: ConfigurationRepository) { }
	execute(): Observable<ConvenioModel> {
	  return this.configRepository.getAllConveniosByEmpresa();
	}
}